import { render, staticRenderFns } from "./bill-form-pay.vue?vue&type=template&id=65877089&scoped=true"
import script from "./bill-form-pay.vue?vue&type=script&lang=js"
export * from "./bill-form-pay.vue?vue&type=script&lang=js"
import style0 from "./bill-form-pay.vue?vue&type=style&index=0&id=65877089&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65877089",
  null
  
)

export default component.exports